export enum CancelEmailChangeConfirmationUserAction {
  CANCEL,
  CONFIRM,
  ERROR,
}
